// src/components/ui/calendar/month/MonthViewEventCard/MonthViewEventCardShadcn.jsx
import React from 'react';
import { cn } from '../../../../../utils/cn';
import {
  Calendar,
  Wrench,
  Network
} from 'lucide-react';

const MonthViewEventCardShadcn = ({
  event,
  onClick,
  showEventPanel = false,
  className = ''
}) => {
  const handleClick = (e) => {
    e.stopPropagation();
    if (!event.isPreview && onClick) {
      onClick(event);
    }
  };

  // Determine event type icon
  const getEventTypeIcon = () => {
    if (event.is_partner_service_event || event.is_referral_event) {
      return <Network className="w-2.5 h-2.5 flex-shrink-0 inline mr-0.5" />;
    }
    if (event.event_category === 'service') {
      return <Wrench className="w-2.5 h-2.5 flex-shrink-0 inline mr-0.5" />;
    }
    return <Calendar className="w-2.5 h-2.5 flex-shrink-0 inline mr-0.5" />;
  };

  // Format time for display
  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  // Build tooltip with full event details
  const buildTooltip = () => {
    const parts = [
      event.title,
      `${formatTime(event.start)} - ${formatTime(event.end)}`
    ];

    if (event.customer?.name) {
      parts.push(`Customer: ${event.customer.name}`);
    }

    if (event.service_type) {
      parts.push(`Service: ${event.service_type}`);
    }

    if (event.is_partner_service_event || event.is_referral_event) {
      parts.push('Partner Event');
    }

    return parts.join('\n');
  };

  return (
    <div
      className={cn(
        // Compact glassmorphism styling for month view
        "text-[11px] px-1.5 py-1 rounded cursor-pointer transition-all duration-300",
        "bg-slate-800/40 backdrop-blur-sm border border-slate-700/50",
        "hover:bg-slate-700/40 hover:border-slate-600/50 hover:scale-105",
        "flex items-center gap-1 overflow-hidden relative",
        event.isPreview && "border-dashed animate-preview-pulse",
        showEventPanel && !event.isPreview && "pointer-events-none opacity-60",
        className
      )}
      onClick={handleClick}
      title={buildTooltip()}
    >
      {/* Glassmorphism gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent pointer-events-none" />

      {/* Color accent dot */}
      <div
        className="flex-shrink-0 w-1.5 h-1.5 rounded-full relative z-10"
        style={{ backgroundColor: event.backgroundColor }}
      />

      <div style={{ color: event.backgroundColor }}>
        {getEventTypeIcon()}
      </div>

      {/* Time */}
      <span className="font-semibold flex-shrink-0 text-slate-200">
        {formatTime(event.start)}
      </span>

      {/* Title (truncated) */}
      <span className="truncate text-slate-300">
        {event.title}
      </span>

      {/* Preview indicator (very minimal) */}
      {event.isPreview && (
        <span className="text-[9px] flex-shrink-0 text-blue-400">(P)</span>
      )}
    </div>
  );
};

export default MonthViewEventCardShadcn;